/* istanbul ignore file */

export const OVERALL_RATING_HEADER = 'Overall product rating';
